import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./layout/Layout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Ocjene from "./pages/Ocjene";
import Logout from "./pages/Logout";
import Ispiti from "./pages/Ispiti";
import Biljeske from "./pages/Biljeske";
import Izostanci from "./pages/Izostanci";
import Raspored from "./pages/Raspored";
import Poruke from "./pages/Poruke";
import NastavniMaterijali from "./pages/NastavniMaterijali";
import PregledPoruke from "./pages/PregledPoruke";
import ZavrsneOcjene from "./pages/ZavrsneOcjene";

function App() {
    // console.log(" >>>>>>> process.env.REACT_APP_PREDMETI_PATH: " + process.env.REACT_APP_PREDMETI_PATH);
    // console.log(" >>>>>>> process.env.REACT_APP_PRODUCTION_ROOT_PATH: " + process.env.REACT_APP_PRODUCTION_ROOT_PATH);
  return (
    <Layout>
      <Routes>
        <Route 
          path="/" 
          element={<Home />} />
        <Route 
          path="/login" 
          element={<Login rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_LOGIN_PATH} />} />
        <Route 
          path="/logout"
          element={<Logout />} />
        <Route 
          path="/ocjene"
          element={<Ocjene rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_OCJENE_PATH} />} />
{/*         <Route 
          path="/ocjene"
          element={<Ocjene rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_OCJENE_PATH}
                           restPredmeti={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_PREDMETI_PATH} />} /> */}
        {/* <Route path="/ocjene">
          <Route path="/ocjene" element={<Ocjene rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_OCJENE_PATH} />} />
          <Route path="/ocjene" element={<ZavrsneOcjene rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_PREDMETI_PATH} />} />
        </Route> */}
        {/* <Route 
          path="/ocjene"
          element={<><Ocjene rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_OCJENE_PATH} />
                      <ZavrsneOcjene rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_PREDMETI_PATH} /></>} /> */}
        <Route
         path="/zavrsneOcjene"
         element={<ZavrsneOcjene rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_PREDMETI_PATH} />}  />
        <Route 
          path="/ispiti"
          element={<Ispiti rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH+ process.env.REACT_APP_ISPITI_PATH} />} />
        <Route
          path="/biljeske"
          element={<Biljeske rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_BILJESKE_PATH} />}
        />
        <Route
          path="/izostanci"
          element={<Izostanci rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_IZOSTANCI_PATH} />}
        />
        <Route
          path="/raspored"
          element={<Raspored rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_RASPORED_PATH} />}
        />
        <Route
          path="/poruke"
          element={<Poruke rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_PORUKE_PATH} />}
        />
        <Route
          path="/nastavni_materijali"
          element={<NastavniMaterijali rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_NASTAVNI_MATERIJALI_PATH} />}
        />
        {<Route
          path="/pregled_poruke"
          element={<PregledPoruke rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_POSALJI_PORUKU_PATH}/>}
        />}
      </Routes>
    </Layout>
  );
}

export default App;
